 

export const FeedbackIcon = ({ fill = "var(--YW_Body_Top_Right_Tab_Icon_Color)" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4ZM20 17.17L18.83 16H4V4H20V17.17Z" fill={fill}/>
  <path d="M6.94737 11.1321L8.37853 12L7.99874 10.3642L9.26316 9.2636L7.59811 9.12166L6.94737 7.57895L6.29663 9.12166L4.63158 9.2636L5.896 10.3642L5.51621 12L6.94737 11.1321Z" fill={fill}/>
  <path d="M11.8947 11.1321L13.2608 12L12.8983 10.3642L14.1053 9.2636L12.5159 9.12166L11.8947 7.57895L11.2736 9.12166L9.68421 9.2636L10.8912 10.3642L10.5286 12L11.8947 11.1321Z" fill={fill}/>
  <path d="M16.8421 11.1321L18.2733 12L17.8935 10.3642L19.1579 9.2636L17.4928 9.12166L16.8421 7.57895L16.1914 9.12166L14.5263 9.2636L15.7907 10.3642L15.4109 12L16.8421 11.1321Z" fill={fill}/>
</svg>
);

export const feedbackIcon = <FeedbackIcon />